import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Toast, ImageUploader, ImageViewer } from 'antd-mobile'
import { ImageUploadItem } from 'antd-mobile/es/components/image-uploader'
import uuid from 'uuidjs'
import { uploadFile } from "@service/commonService";
import { isIOS, base64ToBlob } from '@src/util'
import "./index.scss";
interface Preview {
  url?: string
  show: boolean
}

type UploadImg = {
  children?: any
  onChanege?: any
  url?: string
}

type OssItemType = {
  id: number
  osskey: string
  osskeySmall: string
}

// const seetp = (time: number) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve('ok')
//     }, time);
//   })
// }

export default forwardRef((props: UploadImg, ref) => {
  const [fileList, setFileList] = useState<ImageUploadItem[]>([])
  const [showPreview, setShowPreview] = useState<Preview>({ url: undefined, show: false })
  const [visible, setVisible] = useState<boolean>(false)
  const uid = uuid.generate()

  useEffect(() => {
    if (props.url) {
      setFileList([{ url: props.url }])
    }
  }, [])

  useImperativeHandle(ref, () => ({
    setFileList: setFileList,
  }));

  // 上传前判断
  const beforeUpload = (file: File) => {
    if (file.type.toLowerCase().indexOf('image') === -1) {
      Toast.show('请选择图片上传！')
      return null
    }
    return file
  }

  // 上传
  const upload = async (file: File) => {
    Toast.show({
      icon: 'loading',
      content: '图片上传中…',
      duration: 0,
      maskClickable: false
    })
    let urlList: any = {
      url: URL.createObjectURL(file)
    }
    await uploadFile(file).then((rs: OssItemType) => {
      Toast.clear()
      urlList = {
        id: rs.id,
        url: URL.createObjectURL(file)
      }
      props.onChanege && props.onChanege([urlList])
    }).catch(() => {
      Toast.show('图片上传失败，请重新上传！')
      setTimeout(() => {
        setFileList([])
      }, 500);
      props.onChanege && props.onChanege([])
    })
    return urlList
  }
  // 预览
  const onPreview = () => {
    setVisible(true)
    setShowPreview(Object.assign({}, showPreview, { show: false }))
  }
  // 查看图片
  const onPreviewFrony = () => {
    setShowPreview({
      url: fileList[0].url,
      show: true
    })
  }
  // 重新上传
  const onReuse = () => {
    (document.getElementById(uid)?.parentNode?.lastChild as HTMLElement).click()
    setShowPreview({ show: false })
  }
  // 删除
  const onDelete = () => {
    setFileList([])
    props.onChanege && props.onChanege([])
    setShowPreview({ show: false })
  }
  // 只取最后一条
  const setFileLists = (file: any) => {
    setFileList([file[file.length - 1]])
    // setFileList([file.at(-1)])
  }
  // 上传
  const upload2 = async (file: Blob) => {
    Toast.show({
      icon: 'loading',
      content: '图片上传中…',
      duration: 0,
      maskClickable: false
    })
    let urlList: any = {
      
    }
    await uploadFile(file).then((rs: OssItemType) => {
      urlList = {
        id: rs.id,
        url: rs.osskey
      }
      props.onChanege && props.onChanege([urlList])
      setFileList([urlList])
      Toast.clear()
    }).catch(() => {
      Toast.show('图片上传失败，请重新上传！')
      setTimeout(() => {
        setFileList([])
      }, 500);
      props.onChanege && props.onChanege([])
    })
  }
  const judgeIsIosJs = (e: any) => {
    try {
      if (e.target.localName == 'i' || e.target.localName == 'div' && isIOS) {
        // 当使用ios系统时特殊处理
        // Toast.show({
        //   icon: 'loading',
        //   content: '图片上传中…',
        //   duration: 0,
        //   maskClickable: false
        // })
        try {
          const win: any = window;
          win['iosAlbum'] = function (data: any) {
            // Toast.clear()
            const fileBlob = base64ToBlob(data, 'png')
            upload2(fileBlob)
            win['iosAlbum'] = undefined
          }
          win.webkit.messageHandlers.photoAlbumAction.postMessage({});
        } catch (e) {
          Toast.show('图片处理失败')
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="uploadImg" onClick={judgeIsIosJs}>
      <ImageUploader
        showUpload
        disableUpload={isIOS}
        value={fileList}
        onChange={setFileLists}
        upload={upload}
        deletable={false}
        preview={false}
        imageFit={'cover'}
        onPreview={onPreviewFrony}
        beforeUpload={beforeUpload}
        multiple={false}
      >
        <div id={uid}>
          {props.children}
        </div>
      </ImageUploader>
      {showPreview.show && <div className="overspread" onClick={() => { setShowPreview(Object.assign({}, showPreview, { show: false })) }}>
        <div className="model" onClick={(e) => { e.stopPropagation() }}>
          <div onClick={onPreview}>预览</div>
          <div onClick={onReuse}>重新上传</div>
          <div onClick={onDelete}>删除</div>
        </div>
      </div>}
      <ImageViewer
        image={showPreview.url}
        visible={visible}
        onClose={() => {
          setVisible(false)
        }}
      />
    </div>
  )
})